// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.remove-label-margin {
  margin-top: -2rem;
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/edozvola/cases/construction-building-procedure/construction-building-procedure.scss"],"names":[],"mappings":"AAEA;EACE,iBAAA;AADF","sourcesContent":["@import 'edozvola-frontend-lib/dist/assets/css/00-settings/colors';\n\n.remove-label-margin {\n  margin-top: -2rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
